import { CreateGoalInput, UpdateGoalInput } from '@akin-home/amplify';
import { Goal } from '@akin-home/goals';

export * from './goalGraphqlToModel';

/** Takes a goal models and parses it to create graphql input */
export const goalModelToCreateGraphql = (input: Goal): CreateGoalInput => ({
  title: input.title,
  emoji: input.emoji,
  habitatID: input.habitatID || undefined,
  start: (input.start || new Date()).toISOString(),
  period: input.period,
  completions_per_period: input.completions_per_period,
  participantIDS: input.participant_ids,
  readGroups: input.readGroups,
  isTemplate: input.isTemplate,
  category_ids: input.category_ids,
  reference_code: input.reference_code,
  color: input.color,
});

export const goalModelToUpdateGraphql = (input: Goal): UpdateGoalInput => ({
  ...goalModelToCreateGraphql(input),
  id: input.id,
});
